export default function miseAJourDate(lignesCommande, date) {
  lignesCommande.forEach(ligne => {
    ligne.dateDebut = date.dateDebut ? date.dateDebut : ligne.dateDebut;
    ligne.dateFin = date.dateFin ? date.dateFin : ligne.dateFin;
    ligne.lignesCommande.forEach(sousLigne => {
      sousLigne.dateDebut = date.dateDebut ? date.dateDebut : sousLigne.dateDebut;
      sousLigne.dateFin = date.dateFin ? date.dateFin : sousLigne.dateFin;
    });
  });
}
